export default "<div *ngFor=\"let item of items\" (click)=\"sort(item)\"  class=\"property\">{{item}}</div>";